import React, { useState } from "react";
import styled from "styled-components";
import { Navbar } from "../components/navbar";
import Background from "../assets/pictures/bg.jpg";
import { scroller } from "react-scroll";
import { MoreAboutSection } from "./homepage/moreAboutSection";
import Signature from "../assets/policy/signature.png";
import Seo from "../components/Seo";
const Header = styled.header`
  width: 100%;
  height: 28rem;
  background: url(${Background}) repeat 0 0;
  display: block;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-position: center;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  .header-title {
    width: 100%;
    background-color: rgba(73, 67, 149, 1);
    color: white;
    padding: 0;

    h1 {
      font-size: 2em;
      font-weight: 600;
      margin-left: 20rem;
    }
  }
  @media (max-width: 46.9em) {
    height: 14rem;
    background-attachment: scroll;
    background-size: cover;
    .header-title {
      padding: 0.5em 0 0 0;
      font-size: 0.5em;
      h1 {
        margin-left: 1rem;
      }
    }
  }
`;

const Container = styled.div`
  position: relative;
  section {
    /* border-bottom: solid thin rgb(220, 220, 220); */
  }
  h1,
  h2 {
    font-family: Arial, Helvetica, sans-serif;
    font-weight: normal;
  }

  h2 {
    font-size: 10px;
  }
  @media (max-width: 46.9em) {
    section {
      margin: 0.2rem 0.5rem;
      padding: 0 0.5em 1em 0.5em;
    }

    h1 {
      font-size: 1em;
      font-weight: bold;
    }

    h2 {
      margin: 0.2em 0 0 1em;
      padding: 0.1em;
      font-size: 0.875em;
    }
  }

  @media (min-width: 47em) {
    section {
      margin: 0.5rem 10rem;
      padding: 0.3rem 10rem;
    }

    h2 {
      /* margin: 0.8em 0 0 7%; */
      padding: 0.2em;
      font-size: 1.2em;
    }

    h1 {
      font-size: 1.875em;
      font-weight: 600;
    }
  }
`;
const Content = styled.div`
  margin: 2rem auto;
  padding: 1rem;
  max-width: 900px;
  font-family: Arial, Helvetica, sans-serif;
  line-height: 1.6;
  color: #333;

  h1,
  h2,
  h3 {
    font-weight: 600;
  }

  h1 {
    font-size: 2rem;
    margin-bottom: 1rem;
  }

  h2 {
    font-size: 1.5rem;
    margin-top: 2rem;
    margin-bottom: 1rem;
  }

  h3 {
    font-size: 1.2rem;
    margin-top: 1rem;
    margin-bottom: 0.5rem;
  }

  p {
    margin: 0.5rem 0;
  }

  ul {
    margin: 0.5rem 0 1rem 2rem;
    list-style-type: disc;
  }

  li {
    margin-bottom: 0.5rem;
  }

  @media (max-width: 768px) {
    padding: 1rem;
    h1 {
      font-size: 1.5rem;
    }
    h2 {
      font-size: 1.25rem;
    }
    h3 {
      font-size: 1rem;
    }
  }
`;
const TabsContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin-bottom: 1rem;
  gap: 0.5rem 2rem;
  padding: 0 0.5rem;
  @media (max-width: 46.9em) {
    gap: 0.25rem 0.5rem;
  }
`;

const TabButton = styled.button`
  padding: 0.5rem 0.75rem;
  border: none;
  border-bottom: 3px solid
    ${(props) => (props.active ? "#494395" : "transparent")};
  background: transparent;
  font-weight: bold;
  font-size: 1rem;
  @media (max-width: 46.9em) {
    font-size: 0.9rem;
  }
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
`;
const SignatureBlock = styled.div`
  margin-top: 3rem;
  img {
    display: block;
    height: 5rem;
    max-width: 100%;
    object-fit: contain;
    margin-bottom: 0.25rem;
  }
  .sig-line {
    width: 16rem;
    max-width: 100%;
    border-top: 1px dotted #333;
    padding-top: 0.4rem;
  }
  p {
    margin: 0.1rem 0;
  }
`;
const NavbarContainer = styled.div`
  position: fixed;
  width: 100%;
  background: rgba(0, 0, 0, 0.4);
  height: 7rem;
  @media (max-width: 46.9em) {
    height: 5rem;
  }
`;
const PrivacyPolicy = () => {
  const [activeTab, setActiveTab] = useState("payment"); // correct initialization

  return (
    <>
      <Seo
        title="Privacy Policy | Markiti"
        description="How Markiti and Keep IT Cool collect and protect your data."
        path="/privacy-policy"
      />

      <Container>
        <NavbarContainer>
          <Navbar />
        </NavbarContainer>
        <Header>
          <div className="header-title">
            <h1>Markiti Policies</h1>
          </div>
        </Header>

        <TabsContainer>
          <TabButton
            active={activeTab === "payment"}
            onClick={() => setActiveTab("payment")}
          >
            Payment Policy
          </TabButton>

          <TabButton
            active={activeTab === "food"}
            onClick={() => setActiveTab("food")}
          >
            Food Safety Policy
          </TabButton>
          <TabButton
            active={activeTab === "privacy"}
            onClick={() => setActiveTab("privacy")}
          >
            Privacy Notice
          </TabButton>
          <TabButton
            active={activeTab === "return"}
            onClick={() => setActiveTab("return")}
          >
            Return Policy
          </TabButton>
        </TabsContainer>

        <div>
          {activeTab === "payment" && (
            <Content>
              <h1>Raino Tech4Impact Ltd Payment Policy</h1>

              <p>
                At Raino Tech4Impact Ltd, we are committed to maintaining
                transparent and efficient payment processes to ensure smooth
                business operations and mutual trust with our partners and
                customers.
              </p>

              <h2>1. Payment Terms</h2>
              <ul>
                <li>
                  All invoices are due immediately upon delivery, after the
                  customer inspects and confirms that the items are in good
                  condition and as ordered.
                </li>
                <li>
                  Any customer wishing to pay on credit must have the agreement
                  authorized by the office at least two weeks in advance through
                  their relationship manager, and only after submitting all the
                  required documentation.
                </li>
              </ul>

              <h2>2. Accepted Payment Methods</h2>
              <h3>Mobile Money Transfers</h3>
              <ul>
                <li>NAIROBI PAYBILL: 4015545 ACCOUNT: INVOICE NUMBER</li>
                <li>NAKURU PAYBILL: 542542 ACCOUNT: 42494</li>
                <li>KISUMU PAYBILL: 542542 ACCOUNT: 42469</li>
                <li>TURKANA PAYBILL: 542542 ACCOUNT: 42483</li>
                <li>HOMABAY PAYBILL: 542542 ACCOUNT: 42468</li>
              </ul>

              <h3>Bank Transfers (EFT)</h3>
              <ul>
                <li>ACCOUNT NAME: RAINO TECH4IMPACT LTD</li>
                <li>BANK NAME: NCBA BANK</li>
                <li>BRANCH NAME: WESTLANDS BRANCH</li>
                <li>ACCOUNT NO: 8239840019</li>
                <li>BANK CODE: 07</li>
                <li>BRANCH CODE: 000</li>
                <li>CITY NAME: NAIROBI</li>
              </ul>

              <h3>Company Cheques (subject to clearance)</h3>
              <ul>
                <li>ACCOUNT NAME: RAINO TECH4IMPACT LTD</li>
                <li>BANK NAME: NCBA BANK</li>
                <li>BRANCH NAME: WESTLANDS BRANCH</li>
                <li>ACCOUNT NO: 8239840019</li>
                <li>BANK CODE: 07</li>
                <li>BRANCH CODE: 000</li>
                <li>CITY NAME: NAIROBI</li>
              </ul>

              <p>
                <strong>Please note:</strong> We do not accept cash payments
                under any circumstances. All transactions must be made through
                the above accepted payment methods.
              </p>

              <h2>3. Credit Accounts</h2>
              <ul>
                <li>
                  Credit facilities may be extended to eligible customers upon
                  review and approval.
                </li>
                <li>
                  Credit limits and terms are determined based on purchase
                  history, creditworthiness, and prior conduct.
                </li>
                <li>
                  All credit accounts must be kept in good standing. Overdue
                  accounts may result in withdrawal of credit privileges.
                </li>
              </ul>

              <h2>4. Dispute Resolution</h2>
              <ul>
                <li>
                  Any invoice disputes must be raised within 2 days of receipt.
                </li>
                <li>
                  Disputes do not exempt clients from paying undisputed amounts
                  by the due date.
                </li>
              </ul>
            </Content>
          )}
          {activeTab === "food" && (
            <Content>
              <h1>Quality &amp; Food Safety Policy</h1>

              <h2>Commitment</h2>
              <p>
                Keep IT Cool Limited is committed to supplying safe, high
                quality food products. We do not compromise food safety for
                speed or cost, and Management will provide the leadership,
                resources and training needed to protect public health and keep
                our products safe and fresh. The management shall ensure the
                policy is communicated, understood and implemented by all its
                stakeholders.
              </p>

              <h2>Purpose</h2>
              <p>
                This policy sets out how Keep IT Cool sources, stores, handles
                and distributes food safely and in line with legal, regulatory
                and customer requirements. It applies to all employees and
                operations.
              </p>

              <h2>Objectives</h2>
              <ul>
                <li>
                  Comply with all applicable food safety laws and customer
                  specifications.
                </li>
                <li>
                  Prevent contamination through strict hygiene, temperature
                  control and traceability.
                </li>
                <li>
                  Continually improve our Food Safety Management System (FSSC
                  22000).
                </li>
                <li>
                  Establish emergency preparedness measures against food safety
                  and quality hazards to guarantee operations continuity.
                </li>
                <li>
                  Train employees to understand and apply their food safety
                  responsibilities.
                </li>
                <li>
                  Set annual food safety targets and verify results through
                  audits. Maintain documented information ensuring adherence to
                  the FSMS operations.
                </li>
              </ul>
              <p>
                Every employee is accountable for applying this policy and shall
                be reviewed annually.
              </p>

              <SignatureBlock>
                <img src={Signature} alt="Managing Director's signature" />
                <div className="sig-line">
                  <p>
                    <strong>Approved by:</strong> Managing Director
                  </p>
                  <p>
                    <strong>Date:</strong> 23rd September 2026
                  </p>
                </div>
              </SignatureBlock>
            </Content>
          )}
          {activeTab === "privacy" && (
            <Content>
              <h1>Privacy Notice</h1>

              <h2>1. Purpose</h2>
              <p>
                This Privacy Notice is designed to help you understand how your
                personal data is collected, used, stored, and shared when you
                interact with our digital platforms, including websites, mobile
                apps, and related services.
              </p>

              <h2>2. What Personal Data We Collect</h2>
              <ul>
                <li>
                  <strong>Identification Information:</strong> Full name, phone
                  number, email address, physical address, gender, age
                </li>
                <li>
                  <strong>Account & Transaction Data:</strong> Order history,
                  payment information, transaction records
                </li>
                <li>
                  <strong>Marketing & Communication Data:</strong> Your
                  preferences, feedback, and responses to surveys (with consent)
                </li>
                <li>
                  <strong>Demographic Data:</strong> Region, occupation, and
                  other non-sensitive data to help us measure impact
                </li>
              </ul>

              <h2>3. How We Use Your Data</h2>
              <ul>
                <li>
                  To deliver and manage orders placed through our platforms
                </li>
                <li>
                  To communicate with you regarding your account, support
                  requests, or updates
                </li>
                <li>To comply with legal or regulatory obligations</li>
                <li>To customize marketing messages</li>
                <li>
                  To evaluate and improve our services and measure
                  organizational impact
                </li>
              </ul>

              <h2>4. Legal Basis for Processing</h2>
              <ul>
                <li>Your consent, where required</li>
                <li>
                  Contractual necessity – to fulfill a product or service you
                  requested
                </li>
                <li>
                  Legal obligation – to comply with tax, audit, or regulatory
                  requirements
                </li>
                <li>
                  Our legitimate interest – to improve services, detect fraud,
                  or respond to your queries
                </li>
              </ul>

              <h2>5. How We Share Your Data</h2>
              <ul>
                <li>Payment processors</li>
                <li>Cloud service and hosting providers</li>
                <li>Customer support tools or platforms</li>
                <li>
                  Regulatory or enforcement authorities, if legally required
                </li>
              </ul>
              <p>
                All third-party partners are bound by confidentiality and data
                protection agreements.
              </p>

              <h2>6. Cross-Border Data Transfers</h2>
              <p>
                We may transfer and store your personal data outside Kenya using
                cloud infrastructure. These transfers comply with the Kenya Data
                Protection Act and are made only to jurisdictions with adequate
                data protection safeguards as recognized by the Office of the
                Data Protection Commissioner (ODPC). We ensure that our cloud
                service providers meet high standards of data privacy and
                security.
              </p>

              <h2>7. How Long We Keep Your Data</h2>
              <ul>
                <li>
                  Order data: Retained as long as necessary to complete the
                  transaction and support customer service
                </li>
                <li>
                  Marketing data: Retained until you withdraw your consent
                </li>
                <li>
                  Demographic data: Retained for impact evaluation for a limited
                  time
                </li>
              </ul>
              <p>We securely dispose of personal data when no longer needed.</p>

              <h2>8. Your Rights as a Data Subject</h2>
              <ul>
                <li>Access your personal data</li>
                <li>Request correction or deletion of inaccurate data</li>
                <li>
                  Withdraw consent at any time, where processing is based on
                  consent
                </li>
                <li>Object to certain types of data processing</li>
                <li>
                  Lodge a complaint with the Office of the Data Protection
                  Commissioner (ODPC)
                </li>
              </ul>
              <p>
                To exercise your rights, contact us at{" "}
                <strong>niaje@raino.co.ke</strong> or{" "}
                <strong>0716888877</strong>.
              </p>

              <h2>9. Cookies and Analytics</h2>
              <p>
                We use cookies and analytics tools to improve your experience,
                analyze usage patterns, and enhance our services. Cookies may be
                managed or disabled via your browser settings.
              </p>
            </Content>
          )}
          {activeTab === "return" && (
            <Content>
              <h1>Returns Policy</h1>

              <h2>1. Purpose</h2>
              <p>
                This policy provides guidelines for processing returns of all
                fish, chicken, and their respective by-products. It ensures
                effective handling of returns while maintaining high customer
                satisfaction and complying with relevant quality standards and
                regulations.
              </p>

              <h2>2. Eligibility for Returns</h2>
              <ul>
                <li>
                  <strong>Visible Quality Defects:</strong> Products exhibiting
                  defects such as discoloration, unpleasant odors, abnormal
                  texture, or other signs of spoilage.
                </li>
                <li>
                  <strong>Non-Conformance:</strong> Products not meeting
                  specifications of the original order, including incorrect or
                  damaged items.
                </li>
                <li>
                  <strong>Customer Dissatisfaction:</strong> Valid complaints
                  about condition or quality upon delivery.
                </li>
                <li>
                  <strong>Unavailable Clients or Ghost Orders:</strong> Returns
                  charged for products delivered to unreachable clients or ghost
                  orders.
                </li>
                <li>
                  <strong>Frozen Products:</strong> Returns of frozen items not
                  communicated on time; delivery fee deducted from relationship
                  managers.
                </li>
              </ul>

              <h2>3. Return Request Process</h2>
              <ul>
                <li>
                  Contact customer support within 24 hours of receiving products
                  to initiate a return request.
                </li>
                <li>No returns on cut and cooked products.</li>
                <li>
                  Provide relevant order details, product specifics, and reasons
                  for the return.
                </li>
              </ul>

              <h2>4. Product Inspection</h2>
              <ul>
                <li>
                  Returned products are inspected by a qualified team member to
                  verify defects or non-conformance.
                </li>
                <li>
                  Inspection determines whether products meet eligibility
                  criteria.
                </li>
              </ul>

              <h2>5. Return Validation</h2>
              <ul>
                <li>
                  Eligible returned products will have their return request
                  validated.
                </li>
                <li>
                  Customers are informed and given instructions on how to
                  proceed.
                </li>
              </ul>

              <h2>6. Return Options</h2>
              <ul>
                <li>
                  <strong>Replacement:</strong> Replacement of returned
                  products, subject to availability.
                </li>
                <li>
                  <strong>Refund:</strong> Refunds processed according to
                  company policies.
                </li>
              </ul>

              <h2>7. Documentation</h2>
              <ul>
                <li>
                  All return requests, validation results, and communications
                  are documented.
                </li>
                <li>
                  Documentation may include photographs, descriptions, and other
                  relevant details.
                </li>
              </ul>

              <h2>8. Responsibility for Costs</h2>
              <ul>
                <li>
                  <strong>Quality Defects/Non-Conformance:</strong> Company
                  covers return costs including shipping.
                </li>
                <li>
                  <strong>Customer Dissatisfaction:</strong> Customer may be
                  responsible for return shipping fees.
                </li>
                <li>
                  <strong>Unavailable Clients/Ghost Orders:</strong> Delivery
                  fees deducted from relationship managers.
                </li>
                <li>
                  <strong>Frozen Products:</strong> Delivery fee deduction
                  applies if return due to late communication.
                </li>
              </ul>

              <h2>9. Communication with Customers</h2>
              <p>
                Timely and clear communication throughout the return process is
                crucial. Updates, resolutions, or actions are communicated
                professionally and respectfully.
              </p>

              <h2>10. Continuous Improvement</h2>
              <p>
                Insights from return requests are analyzed to improve
                distribution processes. Preventive measures are implemented to
                reduce returns and enhance customer satisfaction.
              </p>

              <h2>Conclusion</h2>
              <p>
                This comprehensive Returns Policy ensures transparency,
                fairness, and high product standards. By careful documentation
                and continuous analysis, we aim to minimize returns while
                enhancing overall customer experience and maintaining trust.
              </p>
            </Content>
          )}
        </div>
        <MoreAboutSection />
      </Container>
    </>
  );
};

export default PrivacyPolicy;
